import React, { useRef, useEffect, useMemo, useState } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, ButtonItem, FormRef } from "devextreme-react/form";
import Guid from "../../models/Guid";
import IEnregistrement from '../../models/IEnregistrement';
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import { Button, RadioGroup } from 'devextreme-react';
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionDepots from '../gestion-depots/gestion-depots';
import useApi from '../../hooks/useApi';

interface IConfigurationImprimantesProps {
  isModeSelection?: boolean,
}

export default function ConfigurationImprimantes({ isModeSelection }: IConfigurationImprimantesProps) {
  const imprimanteFormDataSource = useCustomDataSource<any, any>({ path: "enregistrement", primaryKey: "idEnregistrementEntete" });
  const { setMainForm, selectedDataRow: selectedImprimante, setIsFieldModifier, setSelectedDataRow, mode, setMode, isFieldModifier, onFieldDataChanged } = imprimanteFormDataSource;
  const { editorOptions: depotsClientsEditorOption, PopupGestion: PopupGestionDepotsClients } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture });
  const [dataSourceConfig, setDataSourceConfig] = useState<any>();
  const formRef = useRef<FormRef>(null);

  const {
    getData: getConfig,
  } = useApi('Configuration');

  useEffect(() => {
    try {
      const names = 'ACTIVER_IMPRIMANTE_EVOLIS_CARTE_MEMBRE,IMPRIMANTE_EVOLIS_COMMUNICATION_TYPE,IMPRIMANTE_EVOLIS_IP_ADDRESS,IMPRIMANTE_EVOLIS_PORT,FORMAT_PAPIER_FACTURE,MODE_ENREGISTREMENT_COUPON,LARGEUR_IMPRESSION_COUPON_KIOSQUE,NOMBRE_COPIE_IMPRESSION_KIOSQUE'
      getConfig({ customPath: `Configuration/${names}/Config` })
        .then((result) => {
          setSelectedDataRow(
            result
          )
          setDataSourceConfig(result)
        })
        .catch((error) => {
          // console.log()
        })
    } catch (error) {
    }
  }, [])

  const setDataRow = (e: string) => {
    setSelectedDataRow((prev: IEnregistrement) => (
      { ...prev, [e]: Guid.empty.toString() }
    ));
    setIsFieldModifier(true);
  }

  const carteDeMembreEditorOptions = useMemo(() => {
    return {
      dataSource: ["Imprimante par défaut", "Fax", "Microsoft Print to PDF", "Microsoft XPS Document Writer", "OneNote (Desktop)", "OneNote for Windows 10"],
      layout: "horizontal"
    }
  }, []);

  const typeDeCommunicationEditorOptions = useMemo(() => {
    return {
      dataSource: ["Pipe", "TCP"],
      layout: "horizontal",
      value: selectedImprimante.IMPRIMANTE_EVOLIS_COMMUNICATION_TYPE === "0" ? "Pipe" : "TCP",
      onValueChanged: (e: any) => {
        const selectedValue = e.value;
        console.log(selectedValue)
        const newCommunicationType = selectedValue === "Pipe" ? "0" : "1";
        console.log(newCommunicationType)
        setSelectedDataRow((prev: IEnregistrement) => (
          { ...prev, 'IMPRIMANTE_EVOLIS_COMMUNICATION_TYPE': "0" }
        ));
      }
    };
  }, [selectedImprimante.IMPRIMANTE_EVOLIS_COMMUNICATION_TYPE]);

  const formatPapierEditorOptions = useMemo(() => {
    return {
      dataSource: ["Coupon", "Lettre"],
      layout: "horizontal"
    }
  }, []);

  const largeurCouponEditorOptions = useMemo(() => {
    return {
      dataSource: ["Non défini", "3 pouces", "4 pouces", "5 pouces"],
      layout: "horizontal"
    }
  }, []);

  const spinOptions = useMemo(() => {
    return { min: 1, max: 999, showSpinButtons: true, width: 75 }
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  }, []);

  // console.log(imprimanteFormDataSource)
  console.log(dataSourceConfig)
  return (
    <FormListBase data={imprimanteFormDataSource} hideList={true}>
      <FormListBaseToolbar removeBlocked={true} headerText={`${selectedImprimante?.idEnregistrementEntete || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ visible: false, disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Général">
            <div style={{ maxWidth: '425px' }}>
              <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedImprimante || {} as IEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                <GroupItem caption={"Cartes de membres"}>
                  <SimpleItem key={"frm-carte"} dataField={"carte"} editorType={"dxSelectBox"} editorOptions={carteDeMembreEditorOptions}>
                    <Label text={"Imprimante carte de membres"} />
                  </SimpleItem>
                  <GroupItem alignItemLabels={false}>
                    <SimpleItem key={"frm-ACTIVER_IMPRIMANTE_EVOLIS_CARTE_MEMBRE"} dataField={"ACTIVER_IMPRIMANTE_EVOLIS_CARTE_MEMBRE"} editorType={"dxCheckBox"}>
                      <Label text={"Activer l'impression de carte de plastique pour les imprimantes Evolis"} />
                    </SimpleItem>
                  </GroupItem>
                  {selectedImprimante.ACTIVER_IMPRIMANTE_EVOLIS_CARTE_MEMBRE &&
                    <GroupItem>
                      <SimpleItem key={"frm-IMPRIMANTE_EVOLIS_COMMUNICATION_TYPE"} dataField={"IMPRIMANTE_EVOLIS_COMMUNICATION_TYPE"} editorType={"dxSelectBox"}
                        editorOptions={typeDeCommunicationEditorOptions}
                      >
                        <Label text={"Type de communication"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-IMPRIMANTE_EVOLIS_IP_ADDRESS"} dataField={"IMPRIMANTE_EVOLIS_IP_ADDRESS"}>
                        <Label text={"Adresse IP"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-IMPRIMANTE_EVOLIS_PORT"} dataField={"IMPRIMANTE_EVOLIS_PORT"}>
                        <Label text={"Port"} />
                      </SimpleItem>
                    </GroupItem>
                  }
                </GroupItem>
                <GroupItem caption={"Factures"}>
                  <GroupItem>
                    <SimpleItem key={"frm-imprimante"} dataField={"imprimante"} editorType={"dxSelectBox"} editorOptions={carteDeMembreEditorOptions}>
                      <Label text={"Imprimante de factures"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-FORMAT_PAPIER_FACTURE"} dataField={"FORMAT_PAPIER_FACTURE"} editorType={"dxRadioGroup"} editorOptions={formatPapierEditorOptions}>
                      <Label text={"Format de papier par défaut"} />
                    </SimpleItem>
                  </GroupItem>
                  <SimpleItem key={"frm-MODE_ENREGISTREMENT_COUPON"} dataField={"MODE_ENREGISTREMENT_COUPON"} editorType={"dxSelectBox"} editorOptions={carteDeMembreEditorOptions}>
                    <Label text={"Imprimante coupon"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Kiosque"}>
                  <SimpleItem key={"frm-LARGEUR_IMPRESSION_COUPON_KIOSQUE"} dataField={"LARGEUR_IMPRESSION_COUPON_KIOSQUE"} editorType={"dxSelectBox"} editorOptions={largeurCouponEditorOptions}>
                    <Label text={"Largeur du coupon"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-NOMBRE_COPIE_IMPRESSION_KIOSQUE"} dataField={"NOMBRE_COPIE_IMPRESSION_KIOSQUE"} editorType={"dxNumberBox"} editorOptions={spinOptions}>
                    <Label text={"Nombre d'impression"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Vignettes"}>
                  <SimpleItem key={"frm-vignettes"} dataField={"envoieEtatDeCompte"} editorType={"dxSelectBox"} editorOptions={largeurCouponEditorOptions}>
                    <Label text={"Imprimante de vignettes"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Étiquettes"}>
                  <SimpleItem key={"frm-etiquettes"} dataField={"envoieEtatDeCompte"} editorType={"dxSelectBox"} editorOptions={largeurCouponEditorOptions}>
                    <Label text={"Imprimante d'étiquettes"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Bracelets"}>
                  <SimpleItem key={"frm-bracelets"} dataField={"envoieEtatDeCompte"} editorType={"dxSelectBox"} editorOptions={largeurCouponEditorOptions}>
                    <Label text={"Imprimante de bracelets"} />
                  </SimpleItem>
                </GroupItem>
              </Form>
            </div>
          </TabItem>
        </FormListBaseTab> : null}
    </FormListBase>
  );
}